import { render, staticRenderFns } from "./exchange-excel.vue?vue&type=template&id=584e7f3e&"
import script from "./exchange-excel.vue?vue&type=script&lang=js&"
export * from "./exchange-excel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports